import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import WorldHeirarchy from "./views/WorldHierarchy.vue";
import NationalHeirarchy from "./views/NationalHierarchy.vue";
import NationalRepresentatives from "./views/NationalRepresentatives.vue";
import AdminPanel from "./views/AdminPanel.vue";
import Events from "./views/Events.vue";
import Photos from "./views/Photos.vue";
import Videos from "./views/Videos.vue";
import Links from "./views/Links.vue";
import ContactUs from "./views/ContactUs.vue";
import UserList from "./views/UserList.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/world-hierarchy",
      name: "worldHeirarchy",
      component: WorldHeirarchy,
    },
    {
      path: "/national-hierarchy",
      name: "nationalHeirarchy",
      component: NationalHeirarchy,
    },
    {
      path: "/national-representatives",
      name: "nationalRepresentatives",
      component: NationalRepresentatives,
    },
    {
      path: "/administration-panel",
      name: "adminPanel",
      component: AdminPanel,
    },
    {
      path: "/user-list",
      name: "userList",
      component: UserList,
    },
    {
      path: "/events",
      name: "events",
      component: Events,
    },
    {
      path: "/photos",
      name: "photos",
      component: Photos,
    },
    {
      path: "/videos",
      name: "videos",
      component: Videos,
    },
    {
      path: "/links",
      name: "links",
      component: Links,
    },
    {
      path: "/contact-us",
      name: "contactus",
      component: ContactUs,
    }
  ],
});
